import React, { useState, useEffect } from "react";
import "../styles/Auth.css";
import Footer from '../components/Footer';
import Card from '../components/Card';
import BackButton from '../components/BackButton';
import { useParams } from "react-router-dom";
import { getServiceCategories } from '../ServiceAPI/services/api';
import { FileText } from 'lucide-react';

const ServiceCategory = () => {
  const { serviceName, serviceType } = useParams();

  const [categories, setCategories] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  // Fetch categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const data = await getServiceCategories(serviceName, serviceType);

        let categoryArray = [];
        if (Array.isArray(data)) {
          categoryArray = data;
        } else if (data.categories && Array.isArray(data.categories)) {
          categoryArray = data.categories;
        } else if (data.data && Array.isArray(data.data)) {
          categoryArray = data.data;
        }

        setCategories(categoryArray);
        setLoading(false);
      } catch (err) {
        console.error('Error:', err);
        setError('Failed to load categories');
        setLoading(false);
      }
    };

    if (serviceName && serviceType) {
      fetchCategories();
    }
  }, [serviceName, serviceType]);
  return (
    <div className='license-container'>
      {/* Back Button */}
      <div className='p-4'>
        <BackButton />
      </div>

      <div className='mt-16 text-center'>
        <h2 className='text-2xl font-semibold text-gray-800 dark:text-white tracking-wide'>
          {serviceType} - {serviceName}
        </h2>
        <div className='mt-3 w-[200px] h-1 bg-blue-500 mx-auto rounded'></div>
        <p className='mt-4 text-lg text-gray-600 dark:text-gray-300'>
          Select your category to proceed
        </p>
      </div>

      <div className='license-cards-container'>
        {loading ? (
          <p>Loading categories...</p>
        ) : error ? (
          <p>{error}</p>
        ) : (
          categories.map((category) => (
            <Card
              key={category.id}
              title={category.Category}
              content={
                <div>
                  <p>{category.description || `Apply for ${category.Category} category.`}</p>
                  {category.requirements && (
                    <>
                      <p className="mt-2 font-medium">Requirements:</p>
                      <ul className="list-disc pl-5 text-left">
                        {category.requirements.map((req, index) => (
                          <li key={index}>{req}</li>
                        ))}
                      </ul>
                    </>
                  )}
                </div>
              }
              lcolor='bg-blue-500 hover:bg-cyan-600'
              icon={FileText}
              buttonText='Proceed'
              link={`/application-form/${category.Id}`}
            />
          ))
        )}
      </div>

      <div className="footer-spacer"></div>
      <Footer />
    </div>
  );
};

export default ServiceCategory;